import { ToggleButton } from '@mui/material';
import React from 'react';
import { SegmentedToggleGroup } from '../SegmentedToggleGroup';
import { Granularity } from '../../types';

const LABELS: Record<Granularity, string> = {
  day: 'Daily',
  week: 'Weekly',
  month: 'Monthly',
  year: 'Yearly',
};

const ORDER: Granularity[] = ['day', 'week', 'month'];

export default function GranularitySelector({
  value,
  onChange,
}: {
  value: Granularity;
  onChange: (granularity: Granularity) => void;
}) {
  return (
    <SegmentedToggleGroup
      exclusive
      size="small"
      value={value}
      onChange={(_event, next: Granularity | null) => {
        if (next) {
          onChange(next);
        }
      }}
    >
      {ORDER.map(g => (
        <ToggleButton key={g} value={g}>
          {LABELS[g]}
        </ToggleButton>
      ))}
    </SegmentedToggleGroup>
  );
}
